<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row">
          <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
            <label>{{ $t('common_words.evaluation') }}</label>
            <br />
            <el-select
              clearable
              @change="setEvaluation"
              filterable
              class="select-primary custom-width-select shadow-sm audit-form"
              size="large"
              v-model="advancedAuditForm.auditHeaderId"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="(option, index) in advancedAudits"
                class="select-primary"
                :value="option.id"
                :label="option.name"
                :key="index + option.id"
              ></el-option>
            </el-select>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
            <label>{{ $t('common_words.farm') }}</label>
            <br />
            <el-select
              clearable
              @change="setFarm"
              :disabled="disabledFarm"
              filterable
              class="select-primary custom-width-select shadow-sm farm-form"
              size="large"
              v-model="advancedAuditForm.farm_id"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="(option, index) in farms"
                class="select-primary"
                :value="option.id"
                :label="option.name"
                :key="index + option.id"
              ></el-option>
            </el-select>
          </div>
          <div v-if="isLote" class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
            <label>{{ $t('common_words.allotment') }}</label>
            <br />
            <el-select
              clearable
              @change="hideView"
              :disabled="disabledLote"
              filterable
              class="select-primary custom-width-select shadow-sm lote-form"
              size="large"
              v-model="advancedAuditForm.lot_id"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="(option, index) in lots"
                class="select-primary"
                :value="option.id"
                :label="option.name"
                :key="index + '-' + option.id"
              ></el-option>
            </el-select>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
            <br class="media-none" />
            <label>{{ $t('common_words.date') }}</label>
            <br />
            <el-date-picker
              v-if="renderComponent"
              @change="hideView"
              :picker-options="pickerOptions"
              class="shadow-sm date-form"
              v-model="advancedAuditForm.date"
              type="date"
              value-format="yyyy-MM-dd"
              :placeholder="`${$t('common_words.select')}...`"
            >
            </el-date-picker>
          </div>
          <div class="col-6 col-md-4 col-lg-4 col-xl-3">
            <label class="label-primary" style="color: transparent"
              >&nbsp;&nbsp;&nbsp;</label
            ><br />
            <button class="btn btn-info btn-fg" @click.prevent="preload">
              <i class="fa fa-table"></i> {{ $t('common_words.preload') }}
            </button>
          </div>
        </div>
        <br />
      </card>
      <card class="custom-shadow-card-header" v-if="showPreload">
        <form>
          <div class="row">
            <div class="col-12">
              <div class="text-center">
                <div class="form-group has-label">
                  <el-upload
                    drag
                    ref="auditUpload"
                    :action="getAxiosURL() + '/auth/advanced/audits/preload'"
                    :data="getFileRequestData"
                    :headers="headerInfo"
                    :limit="1"
                    :on-exceed="handleExceed"
                    :on-success="handleSuccess"
                    :before-upload="beforeUpload"
                    :file-list="fileList"
                    :auto-upload="false"
                  >
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">
                      {{ $t('common_words.finished_format') }}
                      <em> {{ $t('common_words.click_to_load') }}</em>
                    </div>
                    <div slot="tip" class="el-upload__tip">
                      {{ $t('common_words.xlsx_notice') }}
                    </div>
                  </el-upload>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="text-center" v-if="isCreate()">
                <button
                  style="margin-right: 10px"
                  class="btn btn-info btn-fg"
                  @click.prevent="downloadFormat"
                >
                  <i class="fa fa-file-excel-o"></i
                  >{{ $t('common_words.download_file') }}
                </button>
                <button
                  class="btn btn-info btn-fg"
                  @click.prevent="submitUpload"
                >
                  <i class="fa fa-plus"></i>
                  {{ $t('common_words.validate_file') }}
                </button>
              </div>
            </div>
          </div>
        </form>
        <br />
      </card>
      <capture-confirm
        v-if="showTable"
        module="audit"
        :tasks="advancedAuditTasks"
        :subObservations="subcategoryObservations"
        :photoColumn="photoColumn"
        :farmId="advancedAuditForm.farm_id"
        :observationBySubcategory="true"
        @save="storeAdvancedAuditCapture"
        @delete="clear"
      ></capture-confirm>
    </div>
  </div>
</template>

<script>
import { Axios } from 'src/class/Axios.js';
import { MixinExport } from 'src/mixins/mixin-export';
import { MixinNotification } from 'src/mixins/mixin-notification.js';
import axios from 'axios';
import CaptureConfirm from 'src/components/Forms/CaptureConfirm.vue';
import i18n from 'src/i18n';
import mixinLocation from 'src/util/mixinLocation';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import moment from 'moment';
import SweetAlert from 'src/class/Alerts';

export default {
  components: {
    CaptureConfirm,
  },

  data() {
    return {
      advancedAuditForm: {
        auditHeaderId: null,
        farm_id: null,
        lot_id: null,
        date: moment().format('YYYY-MM-DD hh:mm:ss'),
        auditTasks: [],
        user_id: this.$store.state.auth.user.id,
      },
      showTable: false,
      showPreload: false,
      farms: null,
      advancedAudits: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      headerInfo: {
        Authorization: 'Bearer ' + this.$store.state.auth.token,
      },
      fileList: [],
      lots: [],
      advancedAuditTasks: [],
      subcategoryObservations: [],
      isLote: false,
      photoColumn: false,
      disabledFarm: true,
      disabledLote: true,
    };
  },

  computed: {
    getFileRequestData() {
      let data = {
        auditHeaderId: this.advancedAuditForm.auditHeaderId,
        farm_id: this.advancedAuditForm.farm_id,
        date: moment(this.advancedAuditForm.date).format('YYYY-MM-DD hh:mm:ss'),
      };
      if (this.advancedAuditForm.lot_id) {
        data.lot_id = this.advancedAuditForm.lot_id;
      }
      return data;
    },
  },

  mixins: [
    mixinMasters,
    MixinPermissions,
    MixinNotification,
    MixinExport,
    MixinMenu,
    mixinLocation,
  ],

  watch: {
    '$i18n.locale': 'forceRerender',
  },

  methods: {
    hideView() {
      this.showTable = false;
      this.showPreload = false;
    },

    cleanView() {
      this.showTable = false;
      this.showPreload = false;
      this.advancedAuditForm.auditTasks = [];
    },

    validateFilter() {
      if (this.advancedAuditForm.auditHeaderId == null) {
        this.highlightItem('audit-form');
        return false;
      } else if (this.advancedAuditForm.farm_id == null) {
        this.highlightItem('farm-form');
        return false;
      } else if (this.advancedAuditForm.date == null) {
        this.highlightItem('date-form');
        return false;
      } else if (this.isLote && this.advancedAuditForm.lot_id == null) {
        this.highlightItem('lote-form');
        return false;
      }
      return true;
    },

    preload() {
      this.cleanView();
      if (this.validateFilter()) {
        this.showTable = false;
        this.showPreload = true;
      }
    },

    async getLocation() {
      const locationData = await this.getPosition();
      return {
        lat: locationData.lat,
        lng: locationData.lng,
        alt: locationData.alt,
      };
    },

    getDateWithTime() {
      const filterDate = new Date(this.advancedAuditForm.date);
      const thisDate = new Date();
      const requestDate = new Date(
        filterDate.getFullYear(),
        filterDate.getMonth(),
        filterDate.getDate(),
        thisDate.getHours(),
        thisDate.getMinutes(),
        thisDate.getSeconds()
      );
      return moment(requestDate).format('YYYY-MM-DD HH:mm:ss');
    },

    async storeAdvancedAuditCapture(data) {
      this.showHideLoading(true);
      if (this.isCreate() || this.isUpdate()) {
        this.advancedAuditForm.route = 'advanced/audits/storecaptures';
        this.advancedAuditForm.auditTasks = data.tasksForm;
        const options = { headers: { 'Content-Type': 'multipart/form-data' } };
        let formData = new FormData();
        formData.append('auditHeaderId', this.advancedAuditForm.auditHeaderId);
        formData.append('farm_id', this.advancedAuditForm.farm_id);
        if (this.advancedAuditForm.lot_id) {
          formData.append('lot_id', this.advancedAuditForm.lot_id);
        }
        if (data.image) {
          formData.append('image', data.image);
        }
        if (data.observations) {
          formData.append('observations', data.observations);
        }
        formData.append('date', this.getDateWithTime());
        formData.append('user_id', this.advancedAuditForm.user_id);

        try {
          const location = await this.getLocation();
          formData.append('altitude', location.alt);
          formData.append('longitude', location.lng);
          formData.append('latitude', location.lat);
          formData.append('auditTasks', JSON.stringify(data.tasksForm));
          data.tasksForm.forEach((item) => {
            if (item.photo) {
              formData.append(`photo_${item.id}`, item.photo);
            }
          });
          if (data.subcategoryObservations) {
            formData.append(
              'subcategoryObservations',
              JSON.stringify(data.subcategoryObservations)
            );
          }
          axios
            .post(`auth/${this.advancedAuditForm.route}`, formData, options)
            .then((response) => {
              if (response.status) {
                this.showHideLoading();
                this.showNotification(
                  `${response.data.message}`,
                  'success',
                  'nc-simple-add',
                  i18n.t('common_words.successful_creation_threedots')
                );
                this.softDelete();
              }
            })
            .catch((error) => this.showMessageErrors(error));
        } catch (error) {
          this.showHideLoading();
        }
      } else {
        this.showMessageAccess();
        this.showHideLoading();
      }
    },

    clear() {
      const auditHeader = this.advancedAudits.find(
        (audit) => audit.id === this.advancedAuditForm.auditHeaderId
      );
      SweetAlert.delete(
        i18n.t('common_words.evaluation_capture') + auditHeader.name
      ).then((result) => {
        if (result.value) this.deleteAll();
      });
    },

    softDelete() {
      this.cleanView();
      this.advancedAuditForm = {
        auditHeaderId: this.advancedAuditForm.auditHeaderId,
        farm_id: this.advancedAuditForm.farm_id,
        lot_id: this.advancedAuditForm.lot_id,
        date: moment().format('YYYY-MM-DD hh:mm:ss'),
        user_id: this.$store.state.auth.user.id,
        auditTasks: [],
      };
    },

    deleteAll() {
      this.cleanView();
      this.advancedAuditForm = {
        auditHeaderId: null,
        farm_id: null,
        lot_id: null,
        date: moment().format('YYYY-MM-DD hh:mm:ss'),
        user_id: this.$store.state.auth.user.id,
        auditTasks: [],
      };
    },

    handleExceed(files, fileList) {
      SweetAlert.warning(
        `${i18n.t('ad_audit.limit')} ${files.length}${i18n.t('ad_audit.files')}`
      );
    },

    handleSuccess(res, file) {
      if (res.errors) {
        let html = ``;
        res.errors.forEach((error) => {
          html += `<p> ${error} </p>`;
        });
        SweetAlert.danger(html);
      } else if (res.success) {
        this.advancedAuditTasks = res.success;
        this.subcategoryObservations = res.subcategoryObservations;
        this.photoColumn = res.photoColumn;
        this.showPreload = false;
        this.showTable = true;
      }
      this.$refs.auditUpload.clearFiles();
    },

    beforeUpload(file) {
      const validateDocument = this.validateDocument(file.type);
      if (!validateDocument) {
        return false;
      }
      this.advancedAuditForm.date = moment(this.advancedAuditForm.date).format(
        'YYYY-MM-DD hh:mm:ss'
      );
    },

    validateDocument(fileType) {
      const isXLSX = [
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.ms-excel',
        'application/wps-office.xlsx',
      ].includes(fileType);
      if (!isXLSX) {
        SweetAlert.warning(`${i18n.t('common_words.xlsx_format_notice')}`);
        return false;
      }
      return true;
    },

    submitUpload() {
      if (this.$refs.auditUpload.uploadFiles.length > 0) {
        this.$refs.auditUpload.submit();
      } else {
        SweetAlert.warning(`${i18n.t('common_words.xlsx_format_notice')}`);
      }
    },

    downloadFormat() {
      let self = this;
      let data = self.advancedAuditForm;
      data.route = 'advanced/audits/preformat';
      data.name_file = `${i18n.t('audit.advanced_audit_capture_format')}.xlsx`;
      this.Excel(data, 'POST', true)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => this.showMessageErrors(error));
    },

    getLots(farmId) {
      Axios.getMasters('lots/' + farmId)
        .then((response) => {
          this.lots = response.data.data;
          this.disabledLote = false;
        })
        .catch((error) => this.showMessageErrorsSwalAlert(error));
    },

    setEvaluation() {
      this.advancedAuditForm.farm_id = null;
      this.advancedAuditForm.lot_id = null;
      const selectAudit = Object.values(this.advancedAudits).find(
        (audit) => audit.id === this.advancedAuditForm.auditHeaderId
      );
      this.isLote = selectAudit.catch_type == 1 ? true : false;
      this.disabledFarm = false;
      this.disabledLote = true;
      this.hideView();
    },

    setFarm() {
      this.advancedAuditForm.lot_id = null;
      if (this.isLote) {
        this.getLots(this.advancedAuditForm.farm_id);
      }
      this.hideView();
    },
  },

  created() {
    this.showHideLoading(true);
    if (this.isCreate() || this.isUpdate()) {
      Promise.all([
        Axios.getMasters('farms/farms/only'),
        Axios.getMasters('advanced/audits/captures'),
      ])
        .then(([farmsResponse, advAuditResponse]) => {
          this.farms = farmsResponse.data.data;
          this.advancedAudits = advAuditResponse.data;
          this.showHideLoading();
        })
        .catch((error) => this.showMessageErrorsSwalAlert(error));
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.selectedItemOnMenu('advanced');
  },

  destroyed() {
    this.deselectedItemOnMenu('advanced');
  },
};
</script>
<style>
.table-journals td:empty {
  visibility: hidden;
}

.table-journals td:blank {
  visibility: hidden;
}

.sticky-column {
  position: absolute;
  z-index: 100;
  background: #f8fcfe;
  box-shadow: 5px 0px 5px rgba(195, 209, 226, 0.2),
    0px -1px 0px rgba(195, 209, 226, 1);
}
</style>
<style scope>
.card .avatar {
  height: 100%;
  overflow: hidden;
  border-radius: 0% !important;
  margin-right: 0px !important;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
.avatar {
  width: 100px;
  height: 100px;
  display: block;
}
.avatar-uploader-bad .el-upload {
  border-color: red !important;
}
.general {
  width: 400px;
  height: 141px;
  display: block;
}
.general-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 400px;
  height: 141px;
  line-height: 150px;
  text-align: center;
}
</style>
